import React from 'react';
import styles from './SelectionList.module.scss';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import Text from '../../../../Components/Base/Text/Text';

export interface SelectionListItemScheme {
	id: string;
	name?: string;
	description?: string;
	code?: string;
}

interface Props<T extends SelectionListItemScheme> {
	item: T;
	onClick: (item: T) => void;
	buttonLabel: string;
}

const SelectionListItem = <T extends SelectionListItemScheme>({
	item,
	onClick,
	buttonLabel,
}: Props<T>) => (
	<div className={styles.item}>
		<div className={styles.content}>
			{item.name && <Text tx={item.name} className={styles.title} />}
			{item.description && (
				<Text tx={item.description} className={styles.subtitle} />
			)}
		</div>
		<div>
			<Button
				theme={Theme.GREEN}
				title={buttonLabel}
				onClick={() => onClick(item)}
			/>
		</div>
	</div>
);

export default SelectionListItem;
